import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { $, $$, scrollControl, delay, ANIMATION_CONFIG as CONFIG } from "./recruit-utils.js";

// DOM要素取得
const el = {
  heroImage: $('.p-recruit-hero__image'),
  catchElement: $('.p-recruit-hero__catch'),
  header: $('.l-header--recruitment'),
  subText: $('.p-recruit-hero__sub'),
  anime01: $('.js-recruit-anime01'),
  anime02: $('.js-recruit-anime02'),
  anime04: $('.js-recruit-anime04'),
  heroSection: $('.p-recruit-hero'),
  heroInner: $('.p-recruit-hero__inner'),
  heroContent: $('.p-recruit-hero__content'),
  bgWrap: $('.p-recruit-hero__bg-wrap'),
  leads: $$('.p-recruit-hero__lead')
};

// ハイライトアニメーション完了フラグ
let isTypingHighlightCompleted = false;

export function initHeroAnimation() {
  const heroSection = $('.p-recruit-hero');
  if (!heroSection) return;

  // SVGテキストを即座に非表示にしてFOUCを防ぐ
  if (el.catchElement) {
    const allSvgs = el.catchElement.querySelectorAll('svg');
    allSvgs.forEach(svg => {
      const allPaths = svg.querySelectorAll('path');
      allPaths.forEach(path => {
        path.style.opacity = '0';
        path.style.transition = 'opacity 0.2s ease-in';
      });
    });
  }

  // 初期位置設定（anime01基準の中央配置）
  initInitialPosition();

  // SessionStorageチェック
  const isCompleted = sessionStorage.getItem('recruit_hero_animation_completed');

  if (isCompleted) {
    simpleInit();
  } else {
    initSequence();
  }
}

// 初期位置設定関数
function initInitialPosition() {
  // anime01の高さを取得してコンテンツを中央配置
  if (el.heroContent && el.anime01) {
    // 少し待ってからDOM要素の高さを正確に取得
    setTimeout(() => {
      const anime01Height = el.anime01.offsetHeight;
      const centerOffset = `calc(50svh - ${anime01Height / 2}px)`;
      el.heroContent.style.marginTop = centerOffset;
    }, 100);
  }
}

// 簡易初期化関数（アニメーション完了済みの場合）
function simpleInit() {
  // スクロール制御関連の処理を削除

  // ヘッダーを表示
  if (el.header) {
    el.header.classList.add('is-animated');
  }

  // 基本要素を表示状態に
  if (el.heroImage) {
    el.heroImage.classList.add('is-animated');
  }

  if (el.subText) {
    el.subText.classList.add('is-animated');
  }

  // キャッチ要素を完了状態にしてSVG文字を表示
  if (el.catchElement) {
    el.catchElement.classList.add('is-completed');
  }

  // SVG文字を全て表示状態にする（PC版とSP版の両方）
  const svgs = el.catchElement.querySelectorAll('svg');
  svgs.forEach(svg => {
    const allPaths = svg.querySelectorAll('path');
    const rightsGroup = svg.querySelector('.p-recruit-hero__catch-rights');

    // 全てのpathを確実に表示状態にする
    allPaths.forEach(path => {
      path.style.opacity = '1';
    });

    // ハイライトをアニメーション準備状態に
    if (rightsGroup) {
      const highlightBar = rightsGroup.querySelector('.highlight-bar');
      if (highlightBar) {
        highlightBar.style.opacity = '1';
        highlightBar.style.transform = 'translateX(100%)'; // 右端から開始
        highlightBar.style.transition = 'transform 1.2s ease-out';
      }
      rightsGroup.classList.remove('is-highlighted'); // 一旦クラスを削除
    }
  });

  // anime01を元の位置で表示状態に配置
  if (el.anime01) {
    el.anime01.style.display = 'block';
    el.anime01.style.opacity = '1';
    gsap.set(el.anime01, {
      position: 'relative',
      visibility: 'visible'
    });
  }

  // anime02を最終表示状態にする（通常スクロール版）
  if (el.anime02) {

    // anime01の高さを取得してコンテンツを中央配置
    if (el.heroContent && el.anime01) {
      const anime01Height = el.anime01.offsetHeight;
      const centerOffset = `calc(50svh - ${anime01Height / 2}px)`;
      el.heroContent.style.marginTop = centerOffset;
    }

    // 全てのlead要素を初期状態に
    el.leads.forEach((lead) => {
      gsap.set(lead, {
        opacity: 0, // 全て非表示からスタート
        y: 30 // 下からフェードイン用
      });
    });
  }

  // anime04を表示状態にする
  if (el.anime04) {
    el.anime04.classList.add('is-visible');

    // コマンドを完全に表示（opacityで制御）
    const commandElement = el.anime04.querySelector('.p-recruit-hero__command');
    if (commandElement) {
      commandElement.textContent = '$ rails new your_career';
      gsap.set(commandElement, { opacity: 1 });
    }

    // 矢印を初期状態に設定（非表示）
    const arrow = el.anime04.querySelector('.p-recruit-hero__command-arrow');
    if (arrow) {
      gsap.set(arrow, {
        opacity: 0,
        x: 0
      });
    }
  }

  // ScrollTriggerアニメーションを初期化（通常のスクロール用）
  initAnime02ScrollTrigger();
}

// メイン初期化関数
async function initSequence() {
  // スクロール制御は削除（アニメーションは実行）
  
  await delay(CONFIG.TIMINGS.imageDelay);
  if (el.heroImage) el.heroImage.classList.add('is-animated');
  
  await delay(CONFIG.TIMINGS.typingStart - CONFIG.TIMINGS.imageDelay);
  await startTyping();
  
  await delay(CONFIG.TIMINGS.animeSwitch);
  await switchToAnime02();
}

// SVG版のキャッチアニメーション（タイピング風）
async function startTyping() {
  if (!el.catchElement) return;

  // SVGタイピングアニメーションを実行（ハイライトも含む）
  await startSVGTyping();

  // ヘッダー・サブテキスト表示
  await delay(500); // タイピング完了後の待機時間
  if (el.header) el.header.classList.add('is-animated');
  if (el.subText) {
    await delay(200);
    el.subText.classList.add('is-animated');
  }
}

// SVGタイピングアニメーション
async function startSVGTyping() {
  // PC版とSP版の両方のSVGを取得
  const svgs = el.catchElement.querySelectorAll('svg');
  if (!svgs || svgs.length === 0) return;

  // 現在表示されているSVGを特定
  let activeSvg = null;
  svgs.forEach(svg => {
    const computedStyle = getComputedStyle(svg);
    if (computedStyle.display !== 'none') {
      activeSvg = svg;
    }
  });

  if (!activeSvg) return;

  const allPaths = activeSvg.querySelectorAll('path');
  const rightsGroup = activeSvg.querySelector('.p-recruit-hero__catch-rights');
  const rightsGroupPaths = rightsGroup ? rightsGroup.querySelectorAll('path') : [];

  // 全てのpathを確実に初期状態で非表示にする
  allPaths.forEach(path => {
    path.style.opacity = '0';
    path.style.transition = 'opacity 0.2s ease-in';
  });

  // アニメーション開始
  el.catchElement.classList.add('is-typing');

  // Should be の文字（Rights以外のpath）を順番に表示
  const shouldBePaths = Array.from(allPaths).filter(path =>
    !rightsGroup || !rightsGroup.contains(path)
  );

  for (let i = 0; i < shouldBePaths.length; i++) {
    const path = shouldBePaths[i];
    path.style.opacity = '1';
    await delay(100); // 100msの間隔でタイピング
  }

  // 少し間を空けてから「Rights;」を表示
  await delay(200);

  // Rights;内の文字を一つずつ順番に表示
  for (let i = 0; i < rightsGroupPaths.length; i++) {
    const path = rightsGroupPaths[i];
    path.style.opacity = '1';
    await delay(100);
  }

  // 全ての文字が表示された後にタイピング完了
  el.catchElement.classList.remove('is-typing');
  el.catchElement.classList.add('is-completed');

  // タイピング完了後、少し間を空けてからハイライトを適用
  await delay(300);
  if (rightsGroup) {
    const highlightBar = rightsGroup.querySelector('.highlight-bar');
    if (highlightBar) {
      // 初期状態を設定（右端から開始）
      highlightBar.style.transform = 'translateX(100%)';
      highlightBar.style.opacity = '1';

      // アニメーションで左に移動
      setTimeout(() => {
        highlightBar.style.transition = 'transform 1.2s ease-out';
        highlightBar.style.transform = 'translateX(0)';
        
        // ハイライトアニメーション完了フラグを設定（アニメーション時間1.2s後）
        setTimeout(() => {
          isTypingHighlightCompleted = true;
        }, 1200);
      }, 50);
    }
    rightsGroup.classList.add('is-highlighted');
  }
}


// anime02への切り替え
async function switchToAnime02() {
  if (!el.anime01 || !el.anime02) return;
  
  // Anime01はフェードアウトさせずに残す
  // anime02の位置を設定
  prepareAnime02ForScrollTrigger();
  
  await delay(CONFIG.TIMINGS.anime02Delay);
  
  // ScrollTriggerアニメーションを有効化
  initAnime02ScrollTrigger();
}

// ScrollTrigger用にanime02を準備
function prepareAnime02ForScrollTrigger() {
  if (!el.anime02) return;
  
  // anime01は元の位置のまま（通常配置）
  if (el.anime01) {
    gsap.set(el.anime01, {
      position: 'relative',
      visibility: 'visible'
    });
  }
  
  // anime02は通常の配置のまま
  gsap.set(el.anime02, {
    position: 'relative',
    visibility: 'visible',
    opacity: 1
  });
  
  // anime01の高さを取得してコンテンツを中央配置
  if (el.heroContent && el.anime01) {
    const anime01Height = el.anime01.offsetHeight;
    const centerOffset = `calc(50svh - ${anime01Height / 2}px)`;
    el.heroContent.style.marginTop = centerOffset;
  }
  
  // lead要素の初期状態設定
  el.leads.forEach((lead) => {
    gsap.set(lead, {
      opacity: 0, // 全て非表示からスタート
      y: 30 // 下からフェードイン用
    });
  });
}

// ヒーローセクションのロックを解除
function unlockHeroSection() {
  // ヒーローセクションの固定を解除
  if (el.heroSection) {
    el.heroSection.classList.remove('is-locked');
  }
  document.body.classList.remove('hero-animating');
  
  // bodyのスクロールロックを確実に解除
  scrollControl.unlock();
  
  // ScrollTriggerを更新
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 100);
}

// ScrollTriggerでanime02のアニメーションを初期化
function initAnime02ScrollTrigger() {
  if (!el.anime02) return;
  
  // anime01の高さを取得してコンテンツを中央配置
  if (el.heroContent && el.anime01) {
    const anime01Height = el.anime01.offsetHeight;
    const centerOffset = `calc(50svh - ${anime01Height / 2}px)`;
    el.heroContent.style.marginTop = centerOffset;
  }
  
  // pinアニメーション中のためScrollTriggerを遅延設定
  setTimeout(() => {
    ScrollTrigger.refresh();

    // 各lead要素に個別のScrollTriggerを設定（画面中央基準）
    el.leads.forEach((lead) => {
      // 他のlead要素の干渉を避けるため、初期化時に状態をリセット
      gsap.set(lead, {
        opacity: 0,
        y: 30
      });

      ScrollTrigger.create({
        trigger: lead,
        start: "center 65%",
        onEnter: () => {

          // 現在の要素をフェードイン
          gsap.to(lead, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out"
          });

        }
      });
    });

    // Rightsハイライトのアニメーション
    const rightsElements = $$('.p-recruit-hero__catch-rights');
    if (rightsElements.length > 0) {
      // 初回アニメーション完了をチェック
      const isCompleted = sessionStorage.getItem('recruit_hero_animation_completed');
      
      if (!isCompleted && !isTypingHighlightCompleted) {
        // 初回訪問時でまだタイピング後のハイライトが未完了の場合のみリセット
        rightsElements.forEach(rightsElement => {
          rightsElement.classList.remove('is-highlighted');
          const highlightBar = rightsElement.querySelector('.highlight-bar');
          if (highlightBar) {
            highlightBar.style.opacity = '1';
            highlightBar.style.transform = 'translateX(100%)';
            highlightBar.style.transition = 'transform 1.2s ease-out';
          }
        });
      } else if (isCompleted) {
        // 2回目以降の訪問時はScrollTrigger用にリセット
        rightsElements.forEach(rightsElement => {
          rightsElement.classList.remove('is-highlighted');
          const highlightBar = rightsElement.querySelector('.highlight-bar');
          if (highlightBar) {
            highlightBar.style.opacity = '1';
            highlightBar.style.transform = 'translateX(100%)';
            highlightBar.style.transition = 'transform 1.2s ease-out';
          }
        });
      }

      ScrollTrigger.create({
        trigger: el.catchElement,
        start: "top 80%",
        onEnter: () => {
          rightsElements.forEach(rightsElement => {
            rightsElement.classList.add('is-highlighted');
            
            const highlightBar = rightsElement.querySelector('.highlight-bar');
            if (highlightBar) {
              // 既に完了していない場合のみアニメーション実行
              if (!isTypingHighlightCompleted || isCompleted) {
                setTimeout(() => {
                  highlightBar.style.transform = 'translateX(0)';
                }, 100);
              }
            }
          });
        }
      });
    }
  }, 100);
  
  // anime04のScrollTriggerアニメーション
  if (el.anime04) {
    let hasTyped = false;

    // 初期状態で非表示（opacityで制御して高さを保持）
    const commandElement = el.anime04.querySelector('.p-recruit-hero__command');
    if (commandElement) {
      commandElement.textContent = '$ rails new your_career'; // 高さ確保のため初期テキストを設定
      gsap.set(commandElement, { opacity: 0 });
    }

    ScrollTrigger.create({
      trigger: el.anime04,
      start: "center 65%",
      onEnter: () => {
        if (!hasTyped) {
          el.anime04.classList.add('is-visible');
          if (commandElement) {
            gsap.to(commandElement, { opacity: 1, duration: 0.3 });
          }
          startCommandTypingForScrollTrigger();
          hasTyped = true;
        }
      }
    });
  }
}


// ※ Anime03の白バーアニメーション削除済み

// ScrollTrigger版：コマンドタイピングアニメーション
async function startCommandTypingForScrollTrigger() {
  if (!el.anime04) return;

  const commandElement = el.anime04.querySelector('.p-recruit-hero__command');
  if (!commandElement) return;

  const commandText = '$ rails new your_career';
  
  // 初期状態設定（opacityは既に1になっている）
  commandElement.textContent = '';

  // タイピング実行
  for (let i = 0; i <= commandText.length; i++) {
    commandElement.textContent = commandText.substring(0, i);
    await delay(80); // 80ms間隔でタイピング
  }

  // タイピング完了後、矢印表示
  await delay(300);
  const arrow = el.anime04.querySelector('.p-recruit-hero__command-arrow');
  if (arrow) {
    gsap.to(arrow, {
      opacity: 1,
      x: 0,
      duration: 0.5,
      ease: "power2.out"
    });
  }
  
  // 最終的にアニメーション完了をSessionStorageに記録
  await delay(1000);
  sessionStorage.setItem('recruit_hero_animation_completed', 'true');
}

// ※ 旧版の関数は削除済み（ScrollTrigger版に移行）

// ※ ScrollControllerクラスは削除済み（ScrollTrigger版に移行）

// ヒーロー画像のfixed追従アニメーション（GSAP版）
export function initHeroPinAnimation() {
  const heroImage = $('.p-recruit-hero__image');
  const heroSection = $('.p-recruit-hero');
  const heroWrap = $('.p-recruit-hero__wrap');
  
  if (!heroImage || !heroSection || !heroWrap) return;

  // 全画面サイズで追従アニメーション動作

  // fixed状態のright値を計算
  function getFixedRightValue() {
    const windowWidth = window.innerWidth;
    
    if (windowWidth <= 420) {
      // スマホ：fixed時は 0
      return '0px';
    } else {
      // デスクトップ：親要素の右端に合わせる
      const wrapRect = heroWrap.getBoundingClientRect();
      const rightDistance = windowWidth - wrapRect.right;
      return rightDistance + 'px';
    }
  }

  // absolute状態のright値を計算
  function getAbsoluteRightValue() {
    const windowWidth = window.innerWidth;
    
    if (windowWidth <= 420) {
      // スマホ：absolute時は - clamp(1rem, 6.4vw, 1.5rem) で計算
      const clampValue = Math.min(Math.max(16, windowWidth * 0.064), 24); // clamp(1rem, 6.4vw, 1.5rem)
      return `-${clampValue}px`;
    } else {
      // デスクトップ：absolute時は right 0
      return '0px';
    }
  }

  // セクション範囲内でのabsolute配置のtop値を計算
  function getValidAbsoluteTop() {
    const sectionRect = heroSection.getBoundingClientRect();
    const sectionOffsetTop = heroSection.offsetTop;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // セクション内での中央位置を計算
    const sectionHeight = heroSection.offsetHeight;
    const imageHeight = heroImage.offsetHeight;
    const centerInSection = sectionOffsetTop + (sectionHeight / 2) - (imageHeight / 2);
    
    // 現在のスクロール位置から画面中央位置を計算
    const currentCenterTop = scrollTop + (window.innerHeight / 2) - (imageHeight / 2);
    
    // セクション範囲内に制限
    const maxTop = sectionOffsetTop + sectionHeight - imageHeight;
    const minTop = sectionOffsetTop;
    
    // 適切な位置を返す（セクション範囲内に制限）
    return Math.max(minTop, Math.min(maxTop, Math.max(centerInSection, currentCenterTop)));
  }

  // 初期設定：常にfixed で画面中央固定から開始
  gsap.set(heroImage, {
    position: 'fixed',
    right: getFixedRightValue(),
    top: '50%',
    yPercent: -50,
  });

  // ScrollTriggerでセクション終了時にabsoluteに切り替え
  ScrollTrigger.create({
    trigger: heroSection,
    start: "top top",
    end: "bottom bottom",
    onLeave: () => {
      // セクション終了：適切な範囲内でabsolute固定
      const validTop = getValidAbsoluteTop();
      
      gsap.set(heroImage, {
        position: 'absolute',
        right: getAbsoluteRightValue(),
        top: validTop + 'px',
        yPercent: 0
      });
    },
    onEnterBack: () => {
      // セクション復帰：fixed で追従再開
      gsap.set(heroImage, {
        position: 'fixed',
        right: getFixedRightValue(),
        top: '50%',
        yPercent: -50
      });
    }
  });

  // リサイズ時の処理
  window.addEventListener('resize', () => {
    const currentPosition = getComputedStyle(heroImage).position;
    
    if (currentPosition === 'fixed') {
      // fixed状態の場合はright値を更新
      gsap.set(heroImage, {
        right: getFixedRightValue()
      });
    } else if (currentPosition === 'absolute') {
      // absolute状態の場合は適切な位置で再計算
      const validTop = getValidAbsoluteTop();
      gsap.set(heroImage, {
        right: getAbsoluteRightValue(),
        top: validTop + 'px'
      });
    }
  });
}

// スクロールベースのアニメーション制御用のエクスポート（互換性のため）
export function initHeroScrollAnimation() {
  // 現在のヒーローアニメーションに含まれているため、特に追加処理なし
}